<template>
  <div class="social-image-slider">
    <b-modal v-model="showRemoveImage" type="warn" title="Confirm Deletion" @ok="onConfirmRemoveImage" ok-title="Yes, Delete">
      <p>Are you sure you want to delete this image?</p>
    </b-modal>
    <b-modal 
      v-model="showImagePopup" 
      size="lg"
      modal-class="image-slider-popup-modal"
    >
      <img :src="`${apiUrl}viewFileSocialMediaPost/${socialPost.id}/${modalImageId}/${token}/${modalImageDownloadFilename}?cachebuster=`+ Math.random()" class="post-image-popup" />
      <template #modal-footer="{ ok, cancel, hide }">
        <span></span>
      </template>
    </b-modal>
    <b-modal
      id="image-thumbnail-popup-modal"
      v-model="showImageEditorPopup"
      size="lg"
      modal-class="image-editor-popup-modal"
      >
      <img :src="`${apiUrl}viewFileSocialMediaPost/${socialPost.id}/${modalImageId}/${token}/${modalImageDownloadFilename}`" class="post-image-popup" />
      <template #modal-footer="{ ok, cancel, hide }">
        <div class="image-alt">
          <label :for="'image-alt-'+modalImageId">Image Alt Text</label>
          <input tabindex="1" :name="'image-alt-'+modalImageId" type="text" placeholder="Enter image alt text" class="image-alt-input" :class="altTextClass(modalImageAlt)" v-model="modalImageAlt" :disabled="altDisabled" @blur="imageAltTextUpdated" ref="altTextInput" @keyup.enter="saveAltText"/>
          <button title="Delete Image" class="btn delete-deliverable-btn" @click="deleteImageClicked"><i class="fas fa-trash-alt"></i></button>
        </div>
      </template>
    </b-modal>
    <div class="swiper" v-show="socialPost.files.length > 1" :id="getSliderId">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="file in socialPost.files">
          <div class="image-wrap">
            <span v-if="!isEditor" class="expand-image-icon" :data-fileid="file.id" :data-downloadfile="file.download_filename" @click="expandImage">
              <i class="fas fa-expand-arrows-alt"></i>
            </span>
            <img  :data-fileid="file.id" :data-filealt="file.alt_text" :data-downloadfile="file.download_filename" :src="`${apiUrl}viewFileSocialMediaPost/${file.social_post_id}/${file.id}/${token}/${file.download_filename}?cachebuster=`+ Math.random()" @click="editImage"/>
          </div>
          <div class="alt-text-wrap" :class="altTextClass(file.alt_text)">
            <span class="alt-text">{{ imageAltText(file.alt_text) }}</span>
            <button @click="copyFn(file.alt_text, file.id)" v-if="location == 'summary'"
              :id="`copy-img-alt-text-btn-${file.social_post_id}-${file.id}`" class="btn btn-text btn-copy"
              type="button" data-dismiss="modal"><i :class="getCopyIconClass(file.id)"></i></button>
            <b-tooltip :target="`copy-img-alt-text-btn-${file.social_post_id}-${file.id}`" triggers="hover"
              noninteractive>{{ getCopyTooltipText(file.id) }}</b-tooltip>
            <img v-if="isEditor" :data-fileid="file.id" :data-filealt="file.alt_text" 
              class="edit-image-icon" src="/images/pencil.svg" @click="editImage" />
          </div>
        </div>
      </div>
      <div class="swiper-pagination"></div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>
    <div class="single-image" v-if="socialPost.files.length <= 1" v-for="file in socialPost.files">
      <div class="image-wrap">
        <span v-if="!isEditor" class="expand-image-icon" :data-fileid="file.id" :data-downloadfile="file.download_filename" @click="expandImage">
          <i class="fas fa-expand-arrows-alt"></i>
        </span>
        <img  :data-fileid="file.id" :data-filealt="file.alt_text" :src="`${apiUrl}viewFileSocialMediaPost/${file.social_post_id}/${file.id}/${token}/${file.download_filename}?cachebuster=`+ Math.random()"  @click="editImage"/>
      </div>
      <div class="alt-text-wrap" :class="altTextClass(file.alt_text)">
        <span class="alt-text">{{ imageAltText(file.alt_text) }}</span>
        <button @click="copyFn(file.alt_text, file.id)" 
          v-if="location=='summary'"
          :id="`copy-img-alt-text-btn-${file.social_post_id}-${file.id}`"
          class="btn btn-text btn-copy" type="button" 
          data-dismiss="modal"><i :class="getCopyIconClass(file.id)"></i></button>
        <b-tooltip :target="`copy-img-alt-text-btn-${file.social_post_id}-${file.id}`" 
          triggers="hover" noninteractive>{{ getCopyTooltipText(file.id) }}</b-tooltip>
        <img v-if="isEditor" :data-fileid="file.id" :data-filealt="file.alt_text" 
          class="edit-image-icon" src="/images/pencil.svg" @click="editImage" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
// for some reason neither "swiper/vue" as per swiperjs's vue documentation or "swiper/vue/swiper-vue" as suggested by a stackoverflow question worked
import { Navigation, Pagination, Swiper } from 'swiper';

import "swiper/swiper-bundle.css";

export default {
  data() {
    return {
      swiper: false,
      showImagePopup: false,
      showImageEditorPopup: false,
      showRemoveImage: false,
      modalImageId: false,
      modalImageAlt: "",
      modalImageAltInit: "",
      modalImageDownloadFilename:"",
      copyStates: {},
      copySuccessTimeout: null,
      altDisabled: false,
    }
  },
  components: {
    Swiper,
    Navigation,
    Pagination,
  },
  props: ['socialPost', 'location', 'isEditor', 'namespace'],
  computed: {
	  	...mapState({
		    state (state) {
		      return state[this.namespace]
		    },
		    systemSettings (state, getters) {
		      return getters['systemSettings']
		    },
	 	 }),
    token(){
      return this.$store.getters.authToken;
    },
    apiUrl() {
      return process.env.MIX_API_BASE_URL;
    },
    getSliderId() {
      return this.location+"-image-slider-"+this.socialPost.id;
    },
  },
  methods: {
    imageAltText(imageText) {
      if(!imageText){
        if(!this.isEditor){
          return "No alt text"
        } else {
          return "No alt text, click thumbnail to edit"
        }
      }
      return imageText;
    },
    getSocialNetworkSlugFromId(network_id){
      let network = this.systemSettings.social_networks.filter(network => network.id === network_id)[0];
      return network.api_type;
    },
    altTextClass(altText) {
      if(altText){
        if(altText.length){
          return {};
        }
      }
      return {
        "no-alt": true
      };
    },
    expandImage(e){
      this.modalImageId = e.currentTarget.dataset.fileid;
      this.showImagePopup = true;
    },
    editImage(e){
    	console.log("e.currentTarget.dataset",e.currentTarget.dataset);
      this.modalImageId = e.currentTarget.dataset.fileid;
      this.modalImageAlt = e.currentTarget.dataset.filealt;
      this.modalImageDownloadFilename = e.currentTarget.dataset.downloadfile;
      this.modalImageAltInit = this.modalImageAlt;
      this.showImageEditorPopup = true;
      let that = this;

        let altCheck = setInterval(function(){
          console.log("tick");
          let altText = that.$refs.altTextInput;
          if(altText){
            altText.focus();
            clearInterval(altCheck);
          }
        }, 100);
    },

    saveAltText(e) {
    	console.log("saveAltText");
    	if(this.modalImageAlt === this.modalImageAltInit){
    	  return;
    	}
    	this.altDisabled = true;
    	let that = this;
    	this.$store.dispatch(this.namespace + "updateFileAltTextSocialMediaPost",
    	{
    	  id: this.socialPost.id,
    	  file_id: [this.modalImageId],
    	  value: this.modalImageAlt
    	}).then(function(){
    	  that.altDisabled = false;
    	  that.showImageEditorPopup = false;
    	});
    },
    imageAltTextUpdated(e){
      if(this.modalImageAlt === this.modalImageAltInit){
        return;
      }
      this.altDisabled = true;
      let that = this;
      this.$store.dispatch(this.namespace + "updateFileAltTextSocialMediaPost",
      {
        id: this.socialPost.id,
        file_id: [this.modalImageId],
        value: e.target.value
      }).then(function(){
        that.altDisabled = false;

      });
    },
    deleteImageClicked(e){
      e.preventDefault();
      this.showRemoveImage = true;
    },
    onConfirmRemoveImage(){
      this.$store.dispatch(this.namespace + "removeFileSocialMediaPost", {
        id: this.socialPost.id,
        file_id: [this.modalImageId]
      });
      this.showImageEditorPopup = false;
    },
    createSlider(){
      this.swiper = new Swiper('#'+this.getSliderId, {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        speed: 300,
        spaceBetween: 0,
        rewind: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
        },
      });
    },
    initSlider(){
      this.swiper.init('#'+this.getSliderId);
    },
    async copyFn(valueToCopy, fileId) {
      clearTimeout(this.copySuccessTimeout);
      try {
        const navPer = await navigator.permissions.query({ name: "clipboard-write" });
        if (navPer.state == "granted" || navPer.state == "prompt") {
          try {
            await navigator.clipboard.writeText(valueToCopy);
          } catch {
            console.error("clipboard API error. Cannot copy to clipboard.");
          }
        } else {
          console.log("clipboard API error. Cannot copy to clipboard.");
        }
      } catch {
        try {
          await navigator.clipboard.writeText(valueToCopy);
        } catch {
          console.error("clipboard API error. Cannot copy to clipboard.");
        }
      }
      // Update the icon and tooltip text
      this.$set(this.copyStates, fileId, {
        icon: 'fas fa-check',
        tooltip: 'Copied!'
      });

      // Reset the icon and tooltip text after 2 seconds
      this.copySuccessTimeout = setTimeout(() => {
        this.$set(this.copyStates, fileId, {
          icon: 'far fa-copy',
          tooltip: 'Copy Image Alt Text'
        });
      }, 2000);
    },
    getCopyIconClass(fileId) {
      return this.copyStates[fileId]?.icon || 'far fa-copy';
    },
    getCopyTooltipText(fileId) {
      return this.copyStates[fileId]?.tooltip || 'Copy Image Alt Text';
    },
  },
  mounted(){
    this.createSlider();
    let self = this;
  },
};


</script>